import {
	getGroupSetAction,
	getGroupSetResolved,
	listGroupSets,
	listGroupSetsResolved,
} from '@Actions/groupSets.actions';
import { put, takeLatest, retry } from '@redux-saga/core/effects';
import { AxiosResponse } from 'axios';
import { getGroupSets, getGroupSet } from '@Services/groupSets.services';
import { GetGroupSetResponse, GroupSetsResponse } from '@Types';
import { AnyAction } from 'redux';

export function* listGroupSetsSaga() {
	const payload: AxiosResponse<GroupSetsResponse> = yield retry(5, 15000, getGroupSets);
	yield put(listGroupSetsResolved(payload.data.data));
}

function* watchListGroupSetsSaga() {
	yield takeLatest(listGroupSets, listGroupSetsSaga);
}

export function* getGroupSetSaga(action: AnyAction) {
	const payload: AxiosResponse<GetGroupSetResponse> = yield retry(5, 15000, getGroupSet, action.payload);
	yield put(getGroupSetResolved(payload.data.data));
}

function* watchGetGroupSetSaga() {
	yield takeLatest(getGroupSetAction, getGroupSetSaga);
}

const sagaArray = [watchListGroupSetsSaga(), watchGetGroupSetSaga()];

export default sagaArray;
